import { Vec2 } from "./Vec2";







export class Rectangle {


    ///@brief   Upper left position of the rectangle.
    public p: Vec2

    ///@brief   Size of the rectangle.
    public s: Vec2

    ///@brief   Constructor
    ///@param   p   Upper left position of the rectangle.
    ///@param   s   Size of the rectangle.
    constructor( p: Vec2, s: Vec2 ) {
        this.p = p
        this.s = s
    }

    getCenter(): Vec2 {
        return new Vec2( this.p.x + this.s.x / 2.0, this.p.y + this.s.y / 2.0 )
    }

    getArea(): number {
        return this.s.x * this.s.y
    }

    getUpLeft(): Vec2 {
        return this.p
    }

    getDownRight(): Vec2 {
        return new Vec2( this.p.x + this.s.x, this.p.y + this.s.y )
    }

    isPointInside( point : Vec2 ): boolean {
        if ( point.x < this.p.x ) return false
        if ( point.y < this.p.y ) return false
        if ( point.x > this.p.x + this.s.x ) return false
        if ( point.y > this.p.y + this.s.y ) return false
        return true
    }

    intersects( other: Rectangle ): boolean {
        if ( this.p.x > other.p.x + other.s.x ) return false
        if ( this.p.x + this.s.x < other.p.x ) return false
        if ( this.p.y > other.p.y + other.s.y ) return false
        if ( this.p.y + this.s.y < other.p.y ) return false
        return true
    }

    getRandomPointInside(): Vec2 {
        let x: number = this.p.x + Math.random() * this.s.x
        let y: number = this.p.y + Math.random() * this.s.y
        return new Vec2( x, y )
    }

    toString(): string {
        return `Rectangle( p: (${ this.p.x }, ${ this.p.y }), s: (${ this.s.x }, ${ this.s.y }) )`
    }


};